export default __webpack_public_path__ + "static/media/cross.c22a8edc.svg";